import { ScrollSeekPlaceholderProps } from 'react-virtuoso'

type Props = ScrollSeekPlaceholderProps & { containerClassName?: string, className?: string }

export function ScrollSeekPlaceholder({ containerClassName, className, height }: Props) {
  return (
    <div style={{ height: height + 'px' }} className={containerClassName}>
      <div className={className}></div>
    </div>
  )
}
